/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ClaudeConversationItemResult,
  ClaudeConversationType,
} from "../models/index";
import {
  ClaudeConversationItemResultFromJSON,
  ClaudeConversationItemResultToJSON,
  ClaudeConversationTypeFromJSON,
  ClaudeConversationTypeToJSON,
} from "../models/index";

export interface GetClaudeConversationItemsRequest {
  context: ClaudeConversationType;
  shipmentId?: string | null;
  companyId?: string | null;
}

export interface SendClaudeMessageRequest {
  message: string;
  context: ClaudeConversationType;
  shipmentId?: string | null;
  companyId?: string | null;
}

/**
 *
 */
export class ClaudeApi extends runtime.BaseAPI {
  /**
   */
  async getClaudeConversationItemsRaw(
    requestParameters: GetClaudeConversationItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ClaudeConversationItemResult>>> {
    if (requestParameters["context"] == null) {
      throw new runtime.RequiredError(
        "context",
        'Required parameter "context" was null or undefined when calling getClaudeConversationItems().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["context"] != null) {
      queryParameters["context"] = requestParameters["context"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/claude/get-claude-conversation-items`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ClaudeConversationItemResultFromJSON),
    );
  }

  /**
   */
  async getClaudeConversationItems(
    requestParameters: GetClaudeConversationItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ClaudeConversationItemResult>> {
    const response = await this.getClaudeConversationItemsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async sendClaudeMessageRaw(
    requestParameters: SendClaudeMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["message"] == null) {
      throw new runtime.RequiredError(
        "message",
        'Required parameter "message" was null or undefined when calling sendClaudeMessage().',
      );
    }

    if (requestParameters["context"] == null) {
      throw new runtime.RequiredError(
        "context",
        'Required parameter "context" was null or undefined when calling sendClaudeMessage().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["message"] != null) {
      queryParameters["message"] = requestParameters["message"];
    }

    if (requestParameters["context"] != null) {
      queryParameters["context"] = requestParameters["context"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/claude/send-claude-message`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendClaudeMessage(
    requestParameters: SendClaudeMessageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.sendClaudeMessageRaw(requestParameters, initOverrides);
  }
}
